import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  commonButtonStyle: {
    borderRadius: '58px',
    textDecoration: 'none',
    textAlign: 'center'
  },
  midDescTitle: {
    [theme.breakpoints.down(376)]: {
      width: '101%'
    }
  },
  midThirdImg: {
    [theme.breakpoints.down(376)]: {
      width: ' 226px',
      marginLeft: '51px'
    }
  },
  buttonEssay: {
    display: 'flex',
    maxWidth: 650,
    width: '50%',
    height: 71,
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginTop: '5em'
    },
    [theme.breakpoints.down('md')]: {
      width: '60%'
    },
    [theme.breakpoints.down(786)]: {
      width: '75%',
      height: 40,
      marginBottom: 0,
      fontSize: 20,
      lineHeight: '23px'
    },
    [theme.breakpoints.down(376)]: {
      width: '277px'
    },
    '& > span': {
      display: 'block',
      whiteSpace: 'pre-wrap',
      '& > span': {
        textTransform: 'capitalize'
      }
    }
  },
  buttonTarif: {
    width: '249px',
    padding: '20px 0 20px 0',
    [theme.breakpoints.down(786)]: {
      width: '155px',
      padding: '10px 0 10px 0'
    }
  },
  commonButtonFontStyle: {
    color: 'white',
    fontWeight: 500,
    fontSize: '25px',
    lineHeight: '29px',
    [theme.breakpoints.down(786)]: {
      fontWeight: 500,
      fontSize: '13px',
      lineHeight: '15px'
    }
  },
  graphicTypesSection: {
    // overflowX: "hidden",
    '&:before': {
      content: '""',
      backgroundImage: 'url(/images/background-images/green-background.png)',
      width: '100%',
      paddingBottom: '110%',
      position: 'absolute',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      zIndex: '-1',
      marginTop: 50,
      [theme.breakpoints.up('sm')]: {
        marginTop: -10
      },
      [theme.breakpoints.up('md')]: {
        marginTop: -50
      },
      [theme.breakpoints.up('lg')]: {
        marginTop: -130
      }
    }
  },
  introImgBackground: {
    '& img': { width: '100%' },
    position: 'relative',
    // overflowX: "hidden",
    '&:before': {
      width: 138.59,
      height: 88.34,
      top: -30,
      left: -75,
      transform: 'rotate(-34.65deg)',
      opacity: 0.09,
      content: '""',
      zIndex: '-1',
      position: 'absolute',
      background: 'url(/images/background-images/dots.svg)',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      [theme.breakpoints.up('md')]: {
        width: 366.14,
        height: 233.37,
        top: -70,
        left: -200
      }
    }
  },
  justifyText: {
    textAlign: 'justify'
  },
  labeledImages: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column !important'
    },
    margin: '80px 0px',
    '& > div:last-child': {
      margin: 'auto 30px',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '50%',
      position: 'relative',
      maxWidth: 700,
      [theme.breakpoints.up('sm')]: {
        margin: 'auto'
      },
      '&:before': {
        width: 152.04,
        height: 96.91,
        top: -25,
        left: -65,
        transform: 'rotate(-34.65deg)',
        opacity: 0.09,
        content: '""',
        zIndex: '-1',
        position: 'absolute',
        background: 'url(/images/background-images/dots.svg)',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        [theme.breakpoints.up('md')]: {
          width: 248.64,
          height: 158.48,
          top: -20,
          left: -80
        }
      }
    },
    '& > img': {
      width: '80%',
      [theme.breakpoints.up('sm')]: {
        width: '40%'
      }
    },
    '&:nth-child(1) > img': {
      filter: 'drop-shadow(8px 8px 40px rgba(0, 0, 0, 0.1))',
      borderRadius: 9,
      marginLeft: '-26%',
      [theme.breakpoints.up('sm')]: {
        borderRadius: 22,
        marginLeft: '-2%'
      }
    },
    '&:nth-child(2) > img': {
      filter: 'drop-shadow(25px 21px 38px rgba(0, 0, 0, 0.05))',
      borderRadius: 13,
      marginRight: '-35%',
      [theme.breakpoints.up('sm')]: {
        borderRadius: 34,
        marginRight: '-19%',
        width: '55%',
        marginBottom: -50
      },
      [theme.breakpoints.up('lg')]: {
        marginRight: '-8%'
      }
    },
    '&:nth-child(3) > img': {
      filter: 'drop-shadow(12px 12px 52px rgba(0, 0, 0, 0.11))',
      borderRadius: '8%',
      marginLeft: '-35%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: '-11%',
        width: '55%',
        marginTop: -50
      }
    },
    '&:nth-child(4) > img': {
      filter: 'drop-shadow(20px 20px 41px rgba(0, 0, 0, 0.05))',
      borderRadius: 10,
      marginRight: '-25%',
      [theme.breakpoints.up('sm')]: {
        borderRadius: 18,
        margin: 'auto'
      }
    }
  },
  flexDirectionRowReverse: {
    flexDirection: 'row-reverse'
  },
  textSectionWrapper: {
    width: '80% !important',
    '& > h3': {
      fontSize: '28px',
      color: '#54C278',
      fontWeight: '500'
    },
    '& > p': {
      fontSize: '1rem',
      color: 'black',
      fontWeight: '400'
    }
  },
  doubleButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  CTAButton: {
    backgroundColor: '#54C278',
    color: 'white',
    borderRadius: '20px',
    width: '48%',
    padding: '0.6em 0.3em 0.6em 0.3em',
    [theme.breakpoints.down('sm')]: {
      marginTop: '1em',
      width: '100%'
    }
  },
  imageResponsive: {
    [theme.breakpoints.down('sm')]: {
      margin: '0 !important',
      padding: '0 !important',
      marginBottom: '50px !important'
    }
  }
}));
